import { FiAlertTriangle } from "react-icons/fi";
import { createPortal } from "react-dom";
import styled from "styled-components";

const ConfirmationBackdrop = styled.div`
  position: fixed;
  z-index: 2000;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(12,27,19,.52);
  padding: 18px;
  backdrop-filter: blur(3px);

  .selection-confirmation { width: min(430px, 100%); border-radius: 14px; background: #fff; padding: 22px; box-shadow: 0 24px 70px rgba(0,0,0,.22); }
  .selection-confirmation-icon { display: grid; width: 42px; height: 42px; place-items: center; border-radius: 11px; background: #fff5dc; color: #a8660b; font-size: 19px; }
  h2 { margin: 13px 0 6px; color: #17271f; font-size: 18px; }
  p { margin: 0; color: #66736c; font-size: 11px; line-height: 1.65; }
  .selection-confirmation-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 18px; }
  button { min-height: 42px; border: 1px solid #dfe7e2; border-radius: 9px; background: #fff; padding: 9px 14px; color: #394b41; font-size: 10px; font-weight: 800; cursor: pointer; }
  button.confirm { border-color: #126c3a; background: #126c3a; color: #fff; }

  @media (max-width: 480px) {
    .selection-confirmation-actions { flex-direction: column-reverse; }
    button { width: 100%; }
  }
`;

export const SelectionConfirmation = ({ prompt, onCancel, onConfirm }) => {
  if (!prompt || typeof document === "undefined") return null;
  return createPortal(<ConfirmationBackdrop role="presentation"><section className="selection-confirmation" role="dialog" aria-modal="true" aria-labelledby="selection-confirmation-title"><span className="selection-confirmation-icon"><FiAlertTriangle aria-hidden="true" /></span><h2 id="selection-confirmation-title">{prompt.title}</h2><p>{prompt.description}</p><div className="selection-confirmation-actions"><button type="button" onClick={onCancel}>Cancel</button><button type="button" className="confirm" onClick={onConfirm}>{prompt.confirmLabel}</button></div></section></ConfirmationBackdrop>, document.body);
};
